module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "article-page",
    attrs: {
      "id": "article2"
    }
  }, [_c('div', {
    staticClass: "closer"
  }, [_c('route-item', {
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'go down')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-share social-block",
    class: {
      'open': _vm.openSocial
    }
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/share",
      "title": "Лимонные ароматы Палермо",
      "image": "/static/img/share/share2.jpg",
      "description": "Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.",
      "article": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article2', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('p', [_vm._v("Поделиться")]), _vm._v(" "), _c('opensocial')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                    Лимонные ароматы Палермо\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [(!_vm.isPlaying) ? _c('div', {
    staticClass: "video-bg"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    ref: "button",
    staticClass: "dplayer-bezel-icon",
    on: {
      "click": _vm.playVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('youtube', {
    attrs: {
      "player-width": "560",
      "player-height": "315",
      "video-id": 'uT3tKFkRwK4',
      "player-vars": {
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        rel: 0
      }
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide1.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide2.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide3.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide4.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide5.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide6.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article3/slides/slide7.jpg",
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev custom-arrow-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next custom-arrow-next"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "products-block mobile-hidden"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Коктейль бодрости и свежесть 24 часа\n                        ")]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    staticClass: "products-block desktop-hidden"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperProductOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Коктейль бодрости и свежесть 24 часа\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product5.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" масло для тела\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Легкое масло с бодрящим ароматом "), _c('br'), _vm._v(" для энергии и тонуса\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product6.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" молочко для тела\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Легкое молочко для тела "), _c('br'), _vm._v(" с сочным ароматом цитрусов\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_vm._m(17), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 3')
      }
    }
  }, [_vm._v("\n                    Далее\n                ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Почти все свое детство я провела в Крыму у бабушки. Часто я помогала ей собирать фрукты для компота.\n                        Но вот собирать лимоны на Сицилии для создания органической косметики — это очень приятный и новый опыт\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Весь 2018 год Палермо проведет в статусе культурной столицы Италии: эту должность «Орлиный» (так называют административный центр Сицилии итальянцы) вырвал у нескольких древних городов-претендентов прошедшей весной.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Действительно, Палермо очень красив: эффектная мешанина готики, барокко и арабской архитектуры, парки со старыми лаврами и инжиром, залитые солнцем набережные Тирренского моря — путеводители советуют заложить на осмотр города не менее пяти дней.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Но на деле Палермо всегда был столицей, пусть и очень специальной — итальянских лимонов и всевозможных лимонных удовольствий.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Золотые фрукты на Сицилии начали культивировать в XVIII веке.\n                        Сначала лимонами занимались монахи иезуитского ордена, потом подхватили остальные: плантации оказались прибыльным бизнесом.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        На плодородных почвах вокруг Палермо лимон прижился прекрасно: несмотря на то что город отделяет от Этны около четырех часов езды на машине, богатый минералами вулканический пепел долетает сюда легко, в результате многие лимоны под Палермо доживают до ста лет и дают до тонны плодов с дерева в год. Фрукты здесь особые: их отличает значительная кислотность в сочетании с высоким содержанием сахаристых веществ.\n                        Отчасти дело в климате и составе почв, во многом — в биодинамических техниках земледелия, которые используются местными лимонными хозяйствами.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Те, что заняты в партнерском проекте Weleda, имеют престижный сертификат Demeter, подтверждающий их биодинамический статус: последний означает, что фермерское предприятие прошло трехлетний аудит удобрений, воды и способов возделывания и сбора урожая на подотчетном ему участке.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Для меня стало новостью, что урожай лимонов собирают 3 раза в год и созревший лимон не обязательно должен быть желтым, в зависимости от сезона он может оставаться и зеленым")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-content"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "static/img/article3/inner-img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                            Биодинамическое земледелие придумал Рудольф Штайнер, один из основателей клиники антропософской медицины в швейцарском Арлесхайме, откуда выросла компания Weleda.\n                            Штайнер верил, что в сельское хозяйство, как и в здоровье человека, нельзя вмешиваться агрессивно — и то и другое нужно синхронизировать с естественными биоритмами природы, привлекая энергии воды, света, земли и воздуха. В лимонных садах Weleda фрукты собирают и сортируют исключительно вручную (к слову, лимонные деревья под Палермо плодоносят круглый год).\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            И в итоге столь бережного отношения местные лимоны — образцовые, сочные, ароматные, и в каждом словно заключен небольшой луч островного солнца, что, конечно, передается косметическим продуктам, которые способны зарядить вас энергией и поднять настроение.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Во время прогулки по саду Weleda можно сразу посмотреть и на финальный результат сбора лимонов.\n                        Фермеры с гордостью показывают цитрусовую линейку косметики от Weleda и рассказывают о ней с огромным интересом\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Возможно, со стороны биодинамика может показаться сценарием знаменитого фантастического фильма, где недостающим для всеобщего счастья кусочком пазла оказалась искренняя любовь, в данном случае к природе и своему делу, но этот способ работает — дело Штайнера цветет, пахнет и плодоносит.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product4.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовый "), _c('br'), _vm._v(" дезодорант\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B4%D0%B5%D0%B7%D0%BE%D0%B4%D0%BE%D1%80%D0%B0%D0%BD%D1%82?utm_source=afisha&utm_medium=longread&utm_content=citrus_deodorant&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product5.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" масло для тела\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Легкое масло с бодрящим ароматом "), _c('br'), _vm._v(" для энергии и тонуса\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                Подробнее\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product6.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Цитрусовое "), _c('br'), _vm._v(" освежающее "), _c('br'), _vm._v(" молочко для тела\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Легкое молочко для тела "), _c('br'), _vm._v(" с сочным ароматом цитрусов\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%86/%D1%86%D0%B8%D1%82%D1%80%D1%83%D1%81%D0%BE%D0%B2%D0%BE%D0%B5-%D0%BE%D1%81%D0%B2%D0%B5%D0%B6%D0%B0%D1%8E%D1%89%D0%B5%D0%B5-%D0%BC%D0%BE%D0%BB%D0%BE%D1%87%D0%BA%D0%BE-%D0%B4%D0%BB%D1%8F-%D1%82%D0%B5%D0%BB%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=citrus_body_milk&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                            Подробнее\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа,Ролл-он")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4d2a846","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/articles/article2.vue
// module id = 554
// module chunks = 1